import { useOrganization, useUser } from '@clerk/clerk-react'

/**
 * True when the current user is a global admin in the CURRENT organization.
 *
 * This matches legacy semantics where org:global_admin gates access to protected
 * prompt content like "System Script".
 */
export function useIsGlobalAdmin(): boolean {
  const { user } = useUser()
  const { organization } = useOrganization()

  const memberships = user?.organizationMemberships ?? []
  if (!organization?.id) {
    // Org not yet loaded from Clerk — return false to avoid briefly
    // showing protected UI to the wrong user.
    return false
  }

  return memberships.some(
    (m) =>
      m.organization?.id === organization.id && m.role === 'org:global_admin'
  )
}
